module.exports = __webpack_public_path__ + "img/twitter.60131c36.svg";